<template>
  <div>
    <p class="loading-txt" v-show="!showButton">Loading. Please Wait</p>
    <button v-show="showButton" v-on:click="sendLoad()">
      Get My Estimate!
    </button>
  </div>
</template>
<script src="https://code.jquery.com/jquery-3.4.1.js"></script>

<script>
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { db, storage } from "../assets/db.js";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";

import { seter } from "../assets/set.js";

export default {
  name: "estimateButtonMember",
  props: [
    "fenceAdd",
    "fifthPage",
    "sixthPage",
    "sjLogo",
    "speaker",
    "applybtn",
    "currentZipcodes",
    "isMobile",
    "companies",
    "gps",
    "scheduleButton",
    "isTablet",
    "removalCategory",
    "styleImage",
    "multiFences",
    "categoryOfFence",
    "styleOfFence",
    "heightOfFence",
    "colorOfFence",
    "gateStyle",
    "gateWidth",
    "lengths",
    "fencePricing",
    "extraPanelData",
    "removalDbSource",
    "fenceCapStyle",
    "amountOfRemoval",
    "gates",
    "output",
    "headerone",
    "fencePhoto",
    "amountOfCorners",
    "capStyle",
    "cornersArray",
    "feetFromZero",
    "amountOfHoles",
    "userData",
  ],
  async mounted() {
    // get sj data
    const docRef = doc(db, "products", this.SJfenceID);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      this.quote = docSnap.data()["quote"];
    }
  },
  data() {
    return {
      fenceRemovalCategory: {
        Aluminum: 8,
        "Chain Link": 10,
        "Split Rail": 10,
        "Split Rail with Wire": 10,
        Vinyl: 8,
        Wood: 8,
      },
      taxRate: 0.06625,
      removalForCategory: 0,
      hardHole: this.extraPanelData["hardHole"],
      removalType: this.extraPanelData["removalType"],
      pdfToUploadJobnimbus: null,
      linePosts: 0,
      pdfToUpload: null,
      finalPrice: null,
      showButton: false,
      minProfit: 0,
      datAstyleImage: null,
      datAcategoryOfFence: null,
      datAstyleOfFence: null,
      datAheightOfFence: null,
      datAcolorOfFence: null,
      datAgateStyle: null,
      datAgateWidth: null,
      datAlengths: [],
      datAfencePricing: null,
      datAfenceCapStyle: null,
      datAamountOfRemoval: null,
      datAgates: [],
      datAoutput: null,
      datAheaderone: null,
      datAfencePhoto: null,
      datAamountOfCorners: null,
      datAcapStyle: null,
      datAcornersArray: [],
      datAfeetFromZero: null,
      datAamountOfHoles: null,
      datAuserData: null,
      materialPrice: 0,
      totalMaterialPrice: 0,
      totalLabor: 0,
      grandTotal: 0,
      subTotal: 0,
      taxPrice: 0,
      shipping: 0,
      profitPrice: 0,
      clientRetailPrice: 0,
      standardLaborCharges: 0,
      quote: null,
      SJfenceID: "WOnLJ8BBFyYPxuJkXKkWw8vue5k1",
    };
  },
  watch: {
    output() {
      this.showButton = true;
    },
    showButton() {
      this.getRemovalForCategory();
    },
    fenceAdd() {
      if (this.fenceAdd == true) {
        let newFence = {
          categoryOfFence: this.categoryOfFence,
          styleOfFence: this.styleOfFence,
          heightOfFence: this.heightOfFence,
          colorOfFence: this.colorOfFence,
          gateStyle: this.gateStyle,
          gateWidth: this.gateWidth,
          lengths: this.lengths,
          amountOfRemoval: this.amountOfRemoval,
          gates: this.gates,
          amountOfCorners: this.amountOfCorners,
          capStyle: this.capStyle,
          cornersArray: this.cornersArray,
          feetFromZero: this.feetFromZero,
          amountOfHoles: this.amountOfHoles,
          styleImage: this.styleImage,
        };

        this.multiFences.push(newFence);

        // get minProfit

        let filterItems = this.multiFences.map(function (elem) {
          return {
            Category: elem.categoryOfFence,
            style: elem.styleOfFence,
            height: elem.heightOfFence,
            Color: elem.colorOfFence,
          };
        });

        let array1 = [];

        filterItems.map((element) => {
          let newFence = this.fencePricing.filter(function (item) {
            for (var key in element) {
              if (item[key] === undefined || item[key] != element[key])
                return false;
            }
            return true;
          });
          array1.push(newFence[0]);
        });
        let array2 = array1.map(function (elem) {
          return elem.styleMinProfit;
        });

        let styleMax = Math.max(...array2);
        let accountMax = this.extraPanelData["minProfit"];
        this.minProfit = Math.max(styleMax, accountMax);
      }
    },
  },
  methods: {
    convert$StringToNumber(num) {
      return Math.floor(num.substring(1));
    },
    truncateToDecimals(num) {
      const calcDec = Math.pow(10, 1);
      return Math.trunc(num * calcDec) / calcDec;
    },
    roundTwo(price) {
      if (price == 0) {
        return 0;
      }

      const diviedPrice = Math.ceil(price) / 100;
      const flag =
        this.truncateToDecimals(diviedPrice) - Math.floor(diviedPrice);

      if (flag < 0.5) {
        return (Math.floor(diviedPrice) + 0.5) * 100;
      }
      return Math.round(diviedPrice) * 100;
    },
    numberWithSep(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getCompanyLaborForGate(fencePricing) {
      if (this.datAgates.length > 0) {
        let setCategory = this.datAcategoryOfFence;
        let gates = this.datAgates;

        let filteredForCategory = fencePricing.filter(
          (element) => element.Category === setCategory
        );

        if (filteredForCategory.length > 0) {
          let laborForGate = {
            "10' Double Gate": filteredForCategory[0]["10' Double Gate"],
            "3' Gate": filteredForCategory[0]["3' Gate"],
            "4' Gate": filteredForCategory[0]["4' Gate"],
            "5' Gate": filteredForCategory[0]["5' Gate"],
            "8' Double Gate": filteredForCategory[0]["8' Double Gate"],
            "6' Double Gate": filteredForCategory[0]["6' Double Gate"],
          };
          let retail = gates.map((element) => laborForGate[element]);

          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;
          return retail.reduce(reducer);
        }
        return 0;
      }
      return 0;
    },
    getCompanyLaborForStyle(filterData) {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;

      let filteredForCategory = filterData.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      if (filteredForHeight.length > 0) {
        return filteredForHeight[0]["styleLabor"];
      }
      return 0;
    },
    getStyleImage(style) {
      return this.multiFences.find((x) => x.styleOfFence == style).styleImage;
    },
    sendLoad() {
      var self = this;
      this.getRemovalForCategory();

      if (this.amountOfRemoval != 0 && this.removalCategory == null) {
        this.$emit("removalNoCategory");
        return;
      }
      this.$emit("loadingYes");
      setTimeout(function () {
       self.generatePDF();
      }, 200);
    },

    getRemovalForCategory() {
      this.remvoalForCategory = 0;

      if (this.removalCategory != null) {
        this.removalForCategory = this.removalDbSource[this.removalCategory];
      }
    },
    getRemovalForCategoryForCompany(removalDbSource) {
      if (this.removalCategory != null) {
        return removalDbSource[this.removalCategory];
      }
      return 0;
    },
    pdfUploadToCRM(doc, dataForContractor) {
      let docdown = doc;
      let self = this;
      let output = docdown.output();
      let encoded = btoa(output);

      this.$emit("response", encoded);
      this.$emit("loadingNo");

      self.downloadPDF(docdown, dataForContractor);
    },

    generatePDF() {
      // ========================== push fence ======================= //
      let companyHead = [["Company", "Labor", "", "Removal", "", "Total"]];
      let companyInfoBody = [];
      let quickSnapshotHeader = [];
      let quickSnapshotBody = [];
      let fenceInfoBody = [];
      let ourOfferBodyData = [];
      let detailPrice = [];
      let extraPrice = [];
      let labor = [];
      let dataForContractor = {
        pdfBody: {},
      };

      this.materialPrice = 0;
      this.totalMaterialPrice = 0;
      this.totalLabor = 0;
      this.standardLaborCharges = 0;
      this.clientRetailPrice = 0;
      this.subTotal = 0;
      this.profitPrice = 0;

      // format labor of each company
      this.companies.map((element) => {
        element.labor = 0;
        element.post = 0;
        element.removal = 0;
      });

      for (let index = 0; index < this.multiFences.length; index++) {
        this.datAcategoryOfFence = null;
        this.datAstyleOfFence = null;
        this.datAheightOfFence = null;
        this.datAcolorOfFence = null;
        this.datAgateStyle = null;
        this.datAgateWidth = null;
        this.datAlengths = [];
        this.datAamountOfRemoval = null;
        this.datAgates = [];
        this.datAamountOfCorners = null;
        this.datAcapStyle = null;
        this.datAcornersArray = [];
        this.datAfeetFromZero = null;
        this.datAamountOfHoles = null;
        this.datAstyleImage = null;

        this.datAcategoryOfFence = this.multiFences[index]["categoryOfFence"];
        this.datAstyleOfFence = this.multiFences[index]["styleOfFence"];
        this.datAheightOfFence = this.multiFences[index]["heightOfFence"];
        this.datAcolorOfFence = this.multiFences[index]["colorOfFence"];
        this.datAgateStyle = this.multiFences[index]["gateStyle"];
        this.datAgateWidth = this.multiFences[index]["gateWidth"];
        this.datAlengths = this.multiFences[index]["lengths"];
        this.datAamountOfRemoval = this.multiFences[index]["amountOfRemoval"];
        this.datAgates = this.multiFences[index]["gates"];
        this.datAamountOfCorners = this.multiFences[index]["amountOfCorners"];
        this.datAcapStyle = this.multiFences[index]["capStyle"];
        this.datAcornersArray = this.multiFences[index]["cornersArray"];
        this.datAfeetFromZero = this.multiFences[index]["feetFromZero"];
        this.datAamountOfHoles = this.multiFences[index]["amountOfHoles"];
        this.datAstyleImage = this.multiFences[index]["styleImage"];

        // ============================== start main calculation ======================== //

        // this.profitPrice = this.minProfit;

        // geting category of fence
        var categoryOfFence = this.datAcategoryOfFence;

        // Getting PanelRetail
        var panelRetail = this.fenceStyleForPanelRetail;
        // Getting PanelCost
        var panelCost = this.fenceStyleForPanelCost;

        // Getting heightOfFence
        var heightOfFence = this.datAheightOfFence;

        // Getting gateStyle
        var gateStyle = this.datAgateStyle;
        var ifGateStyle;

        if (gateStyle == "Gate") {
          ifGateStyle = "0";
        } else {
          ifGateStyle = this.datAgates.length;
        }
        // Getting number of end posts END

        // Getting gateStyleRetail
        var gateStyleRetail = this.fenceStyleForGatePrice;

        // Getting number of end posts START
        let lengthNumber = this.datAlengths.length;
        // Getting number of end posts END

        // Getting number of regular posts or "line posts" START
        let postSpacing = this.fenceStyleForPostSpacing[0];
        let filteredForRightLengths = this.datAlengths.filter(
          (element) => (element * 12) / postSpacing >= 1
        );
        let filteredForPosts = filteredForRightLengths.map(
          (element) => (element * 12) / postSpacing
        );
        let arrayOfPosts = filteredForPosts.map((element) =>
          Math.ceil(element)
        );
        // Getting number of regular posts or "line posts" END

        // Getting number of panels that needs 0 line posts but exactly 1 panel START
        var exactlyOnePanel = 0;
        filteredForPosts.forEach(function (element) {
          if (element == 1) {
            exactlyOnePanel += 1;
          }
        });
        //sdfsafsa
        // Getting number of panels that needs 0 line posts but exactly 1 panel END

        // Getting number of regular panels START
        let arrayOfPanelCount = filteredForPosts.map((element) =>
          Math.floor(element)
        );

        if (arrayOfPanelCount.length >= 1) {
          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;
          var panelCount = arrayOfPanelCount.reduce(reducer);
          panelCount =
            arrayOfPanelCount.reduce(reducer) -
            this.datAamountOfCorners -
            this.endPosts;
        } else {
          var panelCount = 0;
        }
        // Getting number of regular panels END

        // Getting the lengths of "cut panels" START

        // Getting the lengths of "cut panels" from small cuts START
        let filteredForCutLengths = this.datAlengths.filter(
          (element) => (element * 12) / postSpacing < 1
        );
        let filteredForCuts = filteredForCutLengths.map(
          (element) => element * 12
        );
        // Getting the lengths of "cut panels" from small cuts End

        // Getting the lengths of "cut panels" from big cuts START
        let filteredForCutLengthsOfBigger = this.datAlengths.filter(
          (element) => (element * 12) / postSpacing > 1
        );
        let filteredForCutsOfBigger = filteredForCutLengthsOfBigger.map(
          (element) => element * 12
        );
        // inches of big cuts /\

        // divide that by spacing
        // minus whole number times spacing from inches of big cut

        let filteredDownBiggerForCuts = filteredForCutsOfBigger.map(function (
          element
        ) {
          var fenceLengthMaker = element / postSpacing;
          var fenceLengthMakerDown = Math.floor(fenceLengthMaker);
          var lengthToMinus = (fenceLengthMaker - fenceLengthMakerDown).toFixed(
            2
          );
          var finalReturn = (lengthToMinus * postSpacing).toFixed(2);
          return finalReturn;
        });

        var extraCutsArrayToAdd = filteredDownBiggerForCuts.map((element) =>
          element.toString().slice(0, 5)
        );
        var filteredForCutsLengths = [];
        var arrayToInsert = [];
        filteredForCutsLengths = filteredForCuts.map((element) =>
          element.toString().slice(0, 5)
        );
        arrayToInsert = filteredForCutsLengths.map(
          (element) => " " + element + '"'
        );
        extraCutsArrayToAdd.forEach((element) =>
          arrayToInsert.push(" " + element + '"')
        );
        // Getting the lengths of "cut panels" END
        var extraCutsPriceArray = [];
        extraCutsPriceArray =
          filteredForCutsLengths.concat(extraCutsArrayToAdd);
        var extraCutsPriceArrayNum = extraCutsPriceArray.map((element) =>
          parseFloat(element)
        );
        extraCutsPriceArrayNum = extraCutsPriceArrayNum.filter(
          (element) => element != 0
        );

        var integerReduce = [];
        if (extraCutsPriceArrayNum.length >= 1) {
          // Amount of extra panels needed
          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;
          integerReduce = extraCutsPriceArrayNum.reduce(reducer);
        } else {
        }

        //Knapsack Problem START
        var postSpacingForKnapsack = this.fenceStyleForPostSpacing[0] - 12;

        extraCutsPriceArrayNum.forEach(function (element, index) {
          var i = index;
          if (index < extraCutsPriceArrayNum.length - 1) {
            // iterate over not just the next element but all of the elements in an array //
            i += 1;
            var nextValue = extraCutsPriceArrayNum[i];
            if (element + nextValue < postSpacingForKnapsack) {
              var newValue = element + nextValue;
              var removeValFromIndex = [index, i];
              for (var a = removeValFromIndex.length - 1; a >= 0; a--)
                extraCutsPriceArrayNum.splice(removeValFromIndex[a], 1);
              extraCutsPriceArrayNum.splice(0, 0, newValue);
            } else if (element + nextValue > postSpacingForKnapsack) {
              i += 1;
              var nextNextValue = extraCutsPriceArrayNum[i];
              if (element + nextNextValue < postSpacingForKnapsack) {
                var newValue = element + nextNextValue;
                var removeValFromIndex = [index, i];
                for (var a = removeValFromIndex.length - 1; a >= 0; a--)
                  extraCutsPriceArrayNum.splice(removeValFromIndex[a], 1);
                extraCutsPriceArrayNum.splice(0, 0, newValue);
              } else {
              }
              //embed above if statement
            }
          }
        });

        extraCutsPriceArrayNum.forEach(function (element, index) {
          var i = index;
          if (index < extraCutsPriceArrayNum.length - 1) {
            // iterate over not just the next element but all of the elements in an array //
            i += 1;
            var nextValue = extraCutsPriceArrayNum[i];
            if (element + nextValue < postSpacingForKnapsack) {
              var newValue = element + nextValue;
              var removeValFromIndex = [index, i];
              for (var a = removeValFromIndex.length - 1; a >= 0; a--)
                extraCutsPriceArrayNum.splice(removeValFromIndex[a], 1);
              extraCutsPriceArrayNum.splice(0, 0, newValue);
            } else if (element + nextValue > postSpacingForKnapsack) {
              i += 1;
              var nextNextValue = extraCutsPriceArrayNum[i];
              if (element + nextNextValue < postSpacingForKnapsack) {
                var newValue = element + nextNextValue;
                var removeValFromIndex = [index, i];
                for (var a = removeValFromIndex.length - 1; a >= 0; a--)
                  extraCutsPriceArrayNum.splice(removeValFromIndex[a], 1);
                extraCutsPriceArrayNum.splice(0, 0, newValue);
              } else {
              }
              //embed above if statement
            }
          }
        });

        var extraCutsAmount;
        //Knapsack Problem END
        if (extraCutsPriceArrayNum.length >= 1) {
          extraCutsAmount = extraCutsPriceArrayNum.length;
        } else {
          extraCutsAmount = 0;
        }
        // var extraCutsAmount = Math.ceil(integerReduce / (parseFloat(this.fenceStyleForPostSpacing) - 12));
        if (arrayOfPosts.length >= 1) {
          // var linePosts = arrayOfPosts.reduce(reducer) - this.datAamountOfCorners - this.endPosts + 1;
          var linePosts =
            panelCount +
            this.endPosts +
            this.datAamountOfCorners -
            exactlyOnePanel;
        } else {
          var linePosts = 0;
        }

        var linePostRetail = (
          linePosts * this.fenceStyleForRegularPostRetail
        ).toFixed(2);
        var linePostOurCost = (
          linePosts * this.fenceStyleForRegularPostOurCost
        ).toFixed(2);

        // Getting total price for cut lengths Retail START
        if (extraCutsPriceArrayNum.length >= 1) {
          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;
          var cutPanelTotalCost = extraCutsPriceArrayNum.reduce(reducer);
          var cutPanelTotalCostReduced = cutPanelTotalCost / postSpacing;
          var cutPanelAmount = Math.ceil(cutPanelTotalCostReduced);
          var retailofCutPanels = cutPanelAmount * panelRetail;
        } else {
          var retailofCutPanels = 0;
        }

        // Getting total price for cut lengths Our Cost START
        if (extraCutsPriceArrayNum.length >= 1) {
          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;
          var cutPanelTotalCost = extraCutsPriceArrayNum.reduce(reducer);
          var cutPanelTotalCostReduced = cutPanelTotalCost / postSpacing;
          var cutPanelAmount = Math.ceil(cutPanelTotalCostReduced);
          var ourCostofCutPanels =
            cutPanelAmount * this.fenceStyleForPanelOurCost;
        } else {
          var ourCostofCutPanels = 0;
        }

        var panelRetailPrice =
          (panelCount +
            this.endPosts +
            this.datAamountOfCorners +
            extraCutsAmount) *
          this.fenceStyleForPanelRetail;
        var panelCostPrice =
          (panelCount + this.endPosts + this.datAamountOfCorners) * panelCost;

        var endPostFinalRetail =
          this.endPosts * this.fenceStyleForEndPostRetail;
        var endPostOurCost = this.endPosts * this.fenceStyleForEndPostOurCost;

        var prp = parseFloat(panelRetailPrice);
        var epfr = parseFloat(endPostFinalRetail);
        var lpr = parseFloat(linePostRetail);

        var pcp = parseFloat(panelCostPrice);
        var epoc = parseFloat(endPostOurCost);
        var lpoc = parseFloat(linePostOurCost);

        this.linePosts = linePosts;

        var retailTotalBefore =
          prp +
          this.gateFinalRetail +
          epfr +
          lpr +
          this.cornerRetailFinal +
          this.capRetailFinal;

        var costTotalBefore =
          pcp +
          this.gateFinalCost +
          epoc +
          lpoc +
          this.cornerOurCostFinal +
          this.capRetailOurCost +
          this.amountOfHeavyDutyPostsOurCost;

        var standardLaborCharges = parseFloat(
          (this.endPosts +
            linePosts +
            parseFloat(this.datAamountOfCorners) +
            parseFloat(this.amountOfHeavyDutyPosts)) *
            this.laborCostForStyle +
            this.laborCostForGate
        );

        // standardLaborCharges for each company
        this.companies.map((element) => {
          const laborCostForStyle = this.getCompanyLaborForStyle(
            element.setupYourStyles
          );
          const laborCostForGate = this.getCompanyLaborForGate(
            element.setupYourStyles
          );
          let laborCharge =
            (this.endPosts +
              linePosts +
              parseFloat(this.datAamountOfCorners) +
              parseFloat(this.amountOfHeavyDutyPosts)) *
              laborCostForStyle +
            laborCostForGate;

          const post =
            this.endPosts +
            linePosts +
            parseFloat(this.datAamountOfCorners) +
            parseFloat(this.amountOfHeavyDutyPosts);

          element.labor += this.roundTwo(laborCharge);
          element.post += post;
        });

        var discountPercentArray = this.fenceCapStyle.filter(
          (element) => element.discount
        );
        var discountObject = discountPercentArray.filter(
          (element) =>
            retailTotalBefore >= element.min && retailTotalBefore < element.max
        );
        var retailTotalDifferenceDiscount =
          retailTotalBefore -
          (retailTotalBefore.toFixed(2) -
            retailTotalBefore.toFixed(2) * (discountObject[0].discount / 100));
        var retailTotalAfterDiscount =
          retailTotalBefore.toFixed(2) -
          retailTotalBefore.toFixed(2) * (discountObject[0].discount / 100);

        var ourOfferTotalAfterMaterials =
          costTotalBefore + extraCutsAmount * this.fenceStyleForPanelOurCost;

        // Getting total price for cut lengths END retailTotalDifferenceDiscount
        var amountOfHardHoles = parseFloat(this.amountOfHoles * this.hardHole);
        var amountOfRemovalRetail = parseFloat(
          this.amountOfRemoval * this.removalForCategory
        );

        var totalLaborCharges =
          amountOfRemovalRetail + standardLaborCharges + amountOfHardHoles;

        this.finalPrice = (
          parseFloat(retailTotalAfterDiscount) + parseFloat(totalLaborCharges)
        ).toFixed(2);

        var clientRetail = (
          parseFloat(retailTotalAfterDiscount) + parseFloat(totalLaborCharges)
        ).toFixed(2);

        var totalLaborChargesRetail = totalLaborCharges;
        var profit = parseFloat(
          (
            clientRetail -
            (parseFloat(ourOfferTotalAfterMaterials) +
              parseFloat(totalLaborCharges))
          ).toFixed(2)
        );
        if (profit < this.minProfit) {
          totalLaborChargesRetail = (
            totalLaborCharges +
            this.minProfit -
            (retailTotalAfterDiscount - ourOfferTotalAfterMaterials.toFixed(2))
          ).toFixed(2);
          clientRetail = (
            parseFloat(retailTotalAfterDiscount) +
            parseFloat(totalLaborChargesRetail)
          ).toFixed(2);
          profit = parseFloat(
            (
              clientRetail -
              (parseFloat(ourOfferTotalAfterMaterials) +
                parseFloat(totalLaborCharges))
            ).toFixed(2)
          );
        }

        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        let totallength = this.datAlengths.reduce(reducer);

        let [month, date, year] = new Date().toLocaleDateString().split("/");

        // ============================== TR ======================== //

        let tempDetailPrice = [
          [
            {
              content: "",
              styles: {
                fontStyle: "normal",
                fontSize: "14",
                valign: "bottom",
                minCellHeight: "20",
                minCellWidth: "20",
                textColor: "300",
                fillColor: [200, 200, 200],
              },
            },
            {
              content:
                panelCount +
                this.endPosts +
                this.datAamountOfCorners +
                extraCutsAmount,
              styles: {
                fontStyle: "normal",
                fontSize: "10",
                valign: "center",
                textColor: "300",
                fillColor: [200, 200, 200],
              },
            },
            {
              content: this.datAstyleOfFence,
              styles: {
                fontStyle: "normal",
                fontSize: "10",
                valign: "center",
                textColor: "300",
                fillColor: [200, 200, 200],
              },
            },
            {
              content: this.datAheightOfFence + '"',
              styles: {
                fontStyle: "bold",
                fontSize: "10",
                valign: "center",
                textColor: "300",
                fillColor: [200, 200, 200],
              },
            },
            {
              content: this.datAcolorOfFence,
              styles: {
                fontStyle: "normal",
                fontSize: "10",
                valign: "center",
                textColor: "300",
                fillColor: [200, 200, 200],
              },
            },
            {
              content:
                "$" +
                (
                  panelCostPrice +
                  extraCutsAmount * this.fenceStyleForPanelOurCost
                ).toFixed(2),
              styles: {
                fontStyle: "bold",
                fontSize: "10",
                valign: "center",
                textColor: "300",
                fillColor: [200, 200, 200],
              },
            },
          ],
          [
            "",
            ifGateStyle,
            "Gate(s): " + this.datAgates,
            "",
            this.datAcolorOfFence,
            "$" + this.gateFinalOurCost,
          ],
          [
            "",
            this.endPosts,
            "End Posts ",
            "",
            this.datAcolorOfFence,
            "$" + endPostOurCost.toFixed(2),
          ],
          [
            "",
            linePosts,
            "Line Posts ",
            "",
            this.datAcolorOfFence,
            "$" + linePostOurCost,
          ],
          [
            "",
            this.datAamountOfCorners,
            "Corner Posts ",
            "",
            this.datAcolorOfFence,
            "$" + this.cornerOurCostFinal.toFixed(2),
          ],
          [
            "",
            this.amountOfHeavyDutyPosts,
            "Heavy Duty Posts ",
            "",
            this.datAcolorOfFence,
            "$" + this.amountOfHeavyDutyPostsOurCost.toFixed(2),
          ],
          [
            "",
            this.capQty,
            "Cap Style ",
            "(" + this.datAcapStyle + ")",
            this.datAcolorOfFence,
            "$" + this.capRetailOurCost.toFixed(2),
          ],
        ];
        detailPrice = detailPrice.concat(tempDetailPrice);

        let tempFenceInfoBody = [
          [
            {
              content: this.datAstyleOfFence,
              styles: {
                fontStyle: "normal",
                fontSize: "0",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: this.datAstyleOfFence,
              styles: {
                fontStyle: "normal",
                fontSize: "14",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: this.datAheightOfFence + '"',
              styles: {
                fontStyle: "normal",
                fontSize: "14",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: this.datAcolorOfFence,
              styles: {
                fontStyle: "normal",
                fontSize: "14",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: this.datAgates.length,
              styles: {
                fontStyle: "normal",
                fontSize: "14",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: totallength + "'",
              styles: {
                fontStyle: "normal",
                fontSize: "14",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
          ],
        ];
        fenceInfoBody = fenceInfoBody.concat(tempFenceInfoBody);

        // ============================== end main calculation ======================== //

        this.materialPrice += costTotalBefore;
        this.totalMaterialPrice += ourOfferTotalAfterMaterials;
        this.standardLaborCharges += standardLaborCharges;
        this.clientRetailPrice += clientRetail;
        this.subTotal += Number(parseFloat(ourOfferTotalAfterMaterials));
        this.profitPrice = profit;
      }

      // ============================== Company calculation ======================== //

      var amountOfHardHoles = parseFloat(this.amountOfHoles * this.hardHole);
      var amountOfRemovalRetail = parseFloat(
        this.amountOfRemoval * this.removalForCategory
      );
      var totalLaborCharges =
        amountOfRemovalRetail + this.standardLaborCharges + amountOfHardHoles;
      this.totalLabor = totalLaborCharges;

      this.shipping = 160;
      this.taxPrice = (this.subTotal + this.shipping) * this.taxRate;
      this.grandTotal = this.roundTwo(
        this.subTotal + this.taxPrice + this.shipping
      );

      // totallabor of each company
      this.companies.map((element) => {
        // hardhole
        let hardHole = 0;
        let laborForCategory = element.setupYourStyles.filter(
          (element) => element.Category === this.datAcategoryOfFence
        );
        if (laborForCategory.length > 0) {
          hardHole = Number(laborForCategory[0]["hardHole"]);
        }

        const amountOfHardHoles = parseFloat(this.amountOfHoles * hardHole);

        // removal
        let amountOfRemovalRetail = 0;
        // foot
        if (element.extraPanelData["removalType"] == "foot") {
          let removalForCategory = this.getRemovalForCategoryForCompany(
            element.removalForCategoryPerFoot
          );

          amountOfRemovalRetail = parseFloat(
            this.amountOfRemoval * removalForCategory
          );
        } else {
          // post
          let removalForCategory = this.getRemovalForCategoryForCompany(
            element.removalForCategoryPerPost
          );
          if (this.removalCategory != null) {
            amountOfRemovalRetail = parseFloat(
              (this.amountOfRemoval /
                this.fenceRemovalCategory[this.removalCategory] +
                4) *
                removalForCategory
            );
          }
        }

        // enroll removal for each company
        element.removal += this.roundTwo(amountOfRemovalRetail);
        // get total
        let laborCharge =
          this.roundTwo(amountOfHardHoles) +
          this.roundTwo(amountOfRemovalRetail) +
          this.grandTotal;

        let valueToCompare = 0;

        if (element.post <= 5) {
          valueToCompare = element.extraPanelData["upTo5Posts"];
        } else if (element.post <= 10) {
          valueToCompare = element.extraPanelData["upTo10Posts"];
        } else {
          valueToCompare = element.extraPanelData["upTo10Posts"];
        }
        if (element.labor < valueToCompare) {
          element.labor = this.roundTwo(valueToCompare);
        }

        element.labor += laborCharge;
      });

      // sort company
      this.companies.sort((a, b) => parseFloat(a.labor) - parseFloat(b.labor));

      this.companies.map((element) => {
        let tempFenceInfoBody = [
          [
            {
              content: element.name,
              styles: {
                fontStyle: "bold",
                fontSize: "14",
                halign: "center",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
            {
              content: element.phone,
              styles: {
                fontStyle: "bold",
                fontSize: "14",
                halign: "center",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
          ],
        ];

        companyInfoBody = companyInfoBody.concat(tempFenceInfoBody);
      });

      // check isValidCompany
      if (this.companies.length == 0) {
        companyHead = [["Company Name"]];
        companyInfoBody = [
          [
            {
              content: "Please contact the office for installers in your area",
              styles: {
                fontStyle: "bold",
                halign: "center",
                fontSize: "17",
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            },
          ],
        ];
      }

      // QuickSnapshot Table
      let tempHeaderForQuick = ["Company"];
      let tempAvailability = ["Availability"];
      let tempLaborWarranty = ["Labor Warranty"];
      let tempGateWarranty = ["Gate Warranty"];
      let tempOwnerInstalls = ["Owner Installs"];
      let tempDedicatedOffice = ["Dedicated Office"];
      let tempProjectManager = ["Project Manager"];
      let tempAfterInstallCheck = ["After Install Check"];
      let tempAcceptCredit = ["Accepts Credit\nCards For Labor"];

      this.companies.map((element) => {
        tempHeaderForQuick.push(element.name);
        tempAvailability.push(element.snapshot.availability);
        tempLaborWarranty.push(element.snapshot.laborWarranty);
        tempGateWarranty.push(element.snapshot.gateWarranty);
        tempOwnerInstalls.push({
          content: element.snapshot.ownerInstalls,
          styles: {
            textColor: [255, 255, 255],
          },
        });
        tempDedicatedOffice.push({
          content: element.snapshot.dedicatedOffice,
          styles: {
            textColor: [255, 255, 255],
          },
        });
        tempProjectManager.push({
          content: element.snapshot.projectManager,
          styles: {
            textColor: [255, 255, 255],
          },
        });
        tempAfterInstallCheck.push({
          content: element.snapshot.afterInstallCheck,
          styles: {
            textColor: [255, 255, 255],
          },
        });
        tempAcceptCredit.push({
          content: element.snapshot.acceptCard,
          styles: {
            textColor: [255, 255, 255],
          },
        });
      });
      quickSnapshotHeader.push(tempHeaderForQuick);
      quickSnapshotBody.push(tempAvailability);
      quickSnapshotBody.push(tempLaborWarranty);
      quickSnapshotBody.push(tempGateWarranty);
      quickSnapshotBody.push(tempOwnerInstalls);
      quickSnapshotBody.push(tempDedicatedOffice);
      quickSnapshotBody.push(tempProjectManager);
      quickSnapshotBody.push(tempAfterInstallCheck);
      quickSnapshotBody.push(tempAcceptCredit);

      // ==================================== TR for removal===============================//

      let taxTr = [["", "", "Tax", "", "", "$" + this.taxPrice.toFixed(2)]];

      let shippingTr = [["", "", "Shipping", "", "", "$" + this.shipping]];

      let removalTr = [
        [
          "",
          "",
          "Removal",
          this.removalCategory,
          this.amountOfRemoval + "ft",
          "",
        ],
      ];

      let totalMaterial = [
        [
          {
            content: "",
            styles: {
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "",
            styles: {
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "",
            styles: {
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "Material",
            styles: {
              fontStyle: "bold",
              fontSize: "10",
              halign: "right",

              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content: "Charges:",
            styles: {
              fontStyle: "bold",
              fontSize: "10",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
          {
            content:
              "$" +
              this.totalMaterialPrice.toFixed(
                2
              ) /*+ ourOfferTotalAfterMaterials.toFixed(2)*/,
            styles: {
              fontStyle: "bold",
              fontSize: "10",
              textColor: "300",
              fillColor: [200, 200, 200],
            },
          },
        ],
      ];
      let grandTotal = [
        [
          {
            content: "",
            styles: {
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "",
            styles: {
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "Total",
            styles: {
              fontStyle: "bold",
              halign: "right",

              fontSize: "10",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "Material",
            styles: {
              fontStyle: "bold",
              fontSize: "10",
              halign: "right",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "Charges",
            styles: {
              fontStyle: "bold",
              fontSize: "10",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
          {
            content: "$" + Number(this.grandTotal).toFixed(2),
            styles: {
              fontStyle: "bold",
              fontSize: "10",
              textColor: [255, 255, 255],
              fillColor: [47, 129, 184],
            },
          },
        ],
      ];

      ourOfferBodyData = ourOfferBodyData.concat(detailPrice);
      ourOfferBodyData = ourOfferBodyData.concat(totalMaterial);
      ourOfferBodyData = ourOfferBodyData.concat(shippingTr);
      ourOfferBodyData = ourOfferBodyData.concat(taxTr);
      ourOfferBodyData = ourOfferBodyData.concat(removalTr);
      ourOfferBodyData = ourOfferBodyData.concat(grandTotal);

      // store to pdf for contractor
      dataForContractor.pdfBody = { ...ourOfferBodyData };

      let [month, date, year] = new Date().toLocaleDateString().split("/");

      // =================================== generate pdf =========================== //

      // DOC FOR DOWNLOAD AND UPLOAD TO DB
      let doc = new jsPDF("p", "mm", [140, 180]);

      let customerDoc = new jsPDF("p", "mm", [140, 180]);

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      let heightforphoto = (pageWidth / this.output.width) * this.output.height;
      const widthForMobile =
        ((pageHeight - 25) / this.output.height) * this.output.width;
      const marginXForMobile = (pageWidth - widthForMobile) / 2;
      const marginXForButton = (pageWidth - 50) / 2;

      // get labor range
      let companyCount = this.companies.length;

      let minMum =
        companyCount == 0
          ? 0
          : this.numberWithSep(this.companies[0].labor - this.grandTotal);
      let maxMum =
        companyCount == 0
          ? 0
          : this.numberWithSep(
              this.companies[companyCount - 1].labor - this.grandTotal
            );

      // pg 1
      doc.addImage(
        this.sjLogo,
        "JPEG",
        (pageWidth - 35) / 2,
        5,
        35,
        20,
        undefined,
        "FAST"
      ),
        doc.setFont("Helvetica", "italic"),
        doc.setFontSize(10),
        doc.text(
          this.userData[0].firstName + " " + this.userData[0].lastName,
          10,
          35,
          {
            align: "left",
          }
        ),
        doc.text(this.userData[0].phoneNumber, pageWidth / 2, 35, {
          align: "left",
        }),
        doc.text(this.userData[0].emailAddress, 10, 40, {
          align: "left",
        }),
        doc.text(this.userData[0].homeAddress, 10, 45, {
          maxWidth: 120,
          align: "left",
          lineHeightFactor: 1,
        }),
        doc.setFont("Helvetica", "bold"),
        doc.setFontSize(22),
        doc.text("Your Approximate Cost:", 70, 60, {
          align: "center",
        }),
        doc.setFontSize(16),
        doc.text("Materials: $" + this.numberWithSep(this.grandTotal), 70, 75, {
          align: "center",
        }),
        doc.text("Labor: " + "$" + minMum + "- $" + maxMum, 70, 85, {
          align: "center",
        }),
        doc.addImage(this.speaker, "JPEG", 15, 95, 35, 35),
        doc.setFont("Helvetica", "normal"),
        doc.setFontSize(15),
        doc.text(
          "You can finance your fence materials with no money down and 0% interest for 12 months!",
          60,
          100,
          { maxWidth: 70, align: "left", lineHeightFactor: 1.5 }
        ),
        doc.setFontSize(16),
        doc.setFont("Helvetica", "bold"),
        doc.text("APPLY TODAY - 90 seconds - Instant Approval ", 70, 145, {
          align: "center",
        }),
        doc.addImage(
          this.applybtn,
          (pageWidth - 40) / 2,
          pageHeight - 25,
          40,
          10
        ),
        doc.link((pageWidth - 40) / 2, pageHeight - 25, 40, 10, {
          url: "https://www.mysynchrony.com/mmc/IW223576904",
        });

      // pg 2
      doc.addPage(),
        doc.addImage(this.headerone, 0, 0, pageWidth, 20),
        doc.setFont("Helvetica", "normal"),
        doc.setFontSize(15),
        doc.text(
          "Here's a list of contractors we have personally worked with that will do a great job for a reasonable price.",
          70,
          30,
          { maxWidth: 120, align: "center", lineHeightFactor: 1.5 }
        ),
        doc.autoTable({
          didDrawCell: (data) => {
            if (data.section === "body" && data.column.index === 1) {
              doc.link(
                data.cell.x,
                data.cell.y,
                data.cell.contentWidth,
                data.cell.contentHeight,
                {
                  url: "tel:+8568395992",
                }
              );
            }
          },
          margin: { top: 55 },
          body: companyInfoBody,
        }),
        doc.addImage(
          this.sjLogo,
          "JPEG",
          20,
          pageHeight - 35,
          35,
          23,
          undefined,
          "FAST"
        ),
        doc.setFont("Helvetica", "bold"),
        doc.setFontSize(14),
        doc.text(
          "856-373-4902 675s Evergreen Ave Woodbury NJ 08097",
          100,
          pageHeight - 30,
          {
            maxWidth: 40,
            align: "center",
          }
        );

      // pg 3
      doc.addPage();
      doc.addImage(this.gps, "JPEG", 0, 0, pageWidth, 18, undefined, "FAST");

      if (this.isMobile == true) {
        if (this.isTablet == true) {
          doc.addImage(
            this.output,
            "JPEG",
            0,
            18,
            pageWidth,
            heightforphoto,
            undefined,
            "FAST"
          );
        } else {
          doc.addImage(
            this.output,
            "JPEG",
            marginXForMobile,
            18,
            widthForMobile,
            pageHeight - 25,
            undefined,
            "FAST"
          );
        }
      } else {
        doc.addImage(
          this.output,
          "JPEG",
          0,
          18,
          pageWidth,
          heightforphoto,
          undefined,
          "FAST"
        );
      }

      // pg 4
      doc.addPage();
      doc.autoTable({
        willDrawCell: function (HookData) {
          if (HookData.cell.text == "0") {
            /*&& HookData.column.index === 0) */ HookData.cell.styles.textColor =
              HookData.cell.styles.fillColor;
            HookData.row.height = 0;
            HookData.row.maxCellHeight = 0;
          }
          if (HookData.cell.text == "0ft" && HookData.row.raw[1] == "Removal") {
            HookData.cell.styles.textColor = HookData.cell.styles.fillColor;
            HookData.row.height = 0;
            HookData.row.maxCellHeight = 0;
          }
          if (
            HookData.cell.text == "$0" &&
            HookData.row.raw[1] == "Hard Holes"
          ) {
            HookData.cell.styles.textColor = HookData.cell.styles.fillColor;
            HookData.row.height = 0;
            HookData.row.maxCellHeight = 0;
          }
        },
        didDrawCell: (data) => {
          if (
            data.section === "body" &&
            data.row.height === 20 &&
            data.column.index === 0
          ) {
            let styleImage = this.getStyleImage(data.row.raw[2].content);

            // store image to contractor pdf
            dataForContractor.styleImage = styleImage;

            // draw iamge on the pdf
            doc.addImage(
              styleImage,
              "JPEG",
              data.cell.x + 2,
              data.cell.y + 2,
              15,
              15,
              undefined,
              "FAST"
            );
          }
        },
        margin: { top: 10, left: 5, right: 5 },
        headStyles: { fontStyle: "bold" },
        head: [["", "Qnt.", "Description", "Height", "Color", "Price   "]],
        body: ourOfferBodyData,
      });

      // pg 5
      doc.addPage(),
        doc.addImage(
          this.fifthPage,
          "JPEG",
          0,
          0,
          pageWidth,
          pageHeight,
          undefined,
          "FAST"
        );

      // pg 6
      doc.addPage(),
        doc.addImage(
          this.sixthPage,
          "JPEG",
          0,
          0,
          pageWidth,
          pageHeight,
          undefined,
          "FAST"
        ),
        doc.addImage(this.applybtn, (pageWidth - 49) / 2, 69, 49, 14),
        doc.link((pageWidth - 49) / 2, 69, 49, 14, {
          url: "https://www.mysynchrony.com/mmc/IW223576904",
        });

      // generate customer pdf
      this.pdfUploadToCRM(doc, dataForContractor);
    },

    async downloadPDF(docdown, dataForContractor) {
      docdown.save("FenceProSolutionsEstimate.pdf");
      return;
      // store data to office
      let companies = [];
      this.companies.map((element) => {
        companies.push({
          id: element.id,
          name: element.name,
          email: element.email,
          labor: element.labor,
          removal: element.removal,
          post: element.post,
        });
      });

      // get current date
      let m = new Date();
      let dateString =
        m.getUTCFullYear() +
        "-" +
        (m.getUTCMonth() + 1) +
        "-" +
        m.getUTCDate() +
        " " +
        m.getUTCHours() +
        ":" +
        m.getUTCMinutes() +
        ":" +
        m.getUTCSeconds();

      // get pdf content
      let pdfFile = docdown.output("blob");
      let pdfName =
        this.userData[0].firstName +
        " " +
        this.userData[0].lastName +
        " " +
        dateString;
      // store pdf storage
      let storage = getStorage();
      let pdfRef = ref(storage, "pdf/" + pdfName + ".pdf");

      uploadBytesResumable(pdfRef, pdfFile)
        .then((snapshot) => {
          // Let's get a download URL for the file.
          getDownloadURL(snapshot.ref).then(async (url) => {
            // store project to quote

            this.quote.push({
              pdfForContractor: dataForContractor,
              date: dateString,
              name:
                this.userData[0].firstName + " " + this.userData[0].lastName,
              address: this.userData[0].homeAddress,
              email: this.userData[0].emailAddress,
              phone: this.userData[0].phoneNumber,
              companies: companies,
              pdf: url,
              note: "",
              files: [],
              isSubmit: false,
              contactLink: "",
            });
            const quote = this.quote;

            await updateDoc(doc(db, "products", this.SJfenceID), {
              quote,
            });

            // ...
          });
        })
        .catch((error) => {
          // ...
        });
    },
  },
  computed: {
    laborCostForStyle: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;

      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      return filteredForHeight[0]["styleLabor"];
    },
    laborCostForGate: function () {
      if (this.datAgates.length > 0) {
        let setCategory = this.datAcategoryOfFence;
        let gates = this.datAgates;

        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );

        let laborForGate = {
          "10' Double Gate": filteredForCategory[0]["10' Double Gate"],
          "3' Gate": filteredForCategory[0]["3' Gate"],
          "4' Gate": filteredForCategory[0]["4' Gate"],
          "5' Gate": filteredForCategory[0]["5' Gate"],
          "8' Double Gate": filteredForCategory[0]["8' Double Gate"],
          "6' Double Gate": filteredForCategory[0]["6' Double Gate"],
        };
        let retail = gates.map((element) => laborForGate[element]);

        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        return retail.reduce(reducer);
      }
      return 0;
    },
    endPosts: function () {
      var endPosts;
      if (this.datAcategoryOfFence == "Aluminum") {
        endPosts =
          this.datAcornersArray.length -
          this.datAamountOfCorners +
          this.datAgates.length -
          this.datAfeetFromZero;
      } else {
        endPosts =
          this.datAcornersArray.length -
          this.datAamountOfCorners +
          this.datAgates.length * 2 -
          this.datAfeetFromZero;
      }

      return endPosts;
    },
    gateFinalRetail: function () {
      if (this.datAgates.length >= 1) {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        var gateStyle = this.datAgateStyle + " Retail";

        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );

        let gates = this.datAgates;
        let gates2 = gates.map((element) => element + " Retail");
        let retail = gates2.map((element) => filteredForHeight[0][element]);
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        let retailTotal = retail.reduce(reducer);
        return retailTotal;
      } else {
        return 0;
      }
    },
    gateFinalOurCost: function () {
      if (this.datAgates.length >= 1) {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        var gateStyle = this.datAgateStyle + " Retail";
        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        let gates = this.datAgates;
        let gates2 = gates.map((element) => element + " Our Cost");
        let retail = gates2.map((element) => filteredForHeight[0][element]);
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        let retailTotal = retail.reduce(reducer);
        return retailTotal;
      } else {
        return 0;
      }
    },
    gateFinalCost: function () {
      if (this.datAgates.length >= 1) {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;

        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );

        let gates = this.datAgates;
        let gates2 = gates.map((element) => element + " Our Cost");
        let retail = gates2.map((element) => filteredForHeight[0][element]);

        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;

        let retailTotal = retail.reduce(reducer);

        return retailTotal;
      } else {
        return 0;
      }
    },
    // Setting the data for Post Spacing from Pricing Data
    fenceStyleForPostSpacing: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Spacing between posts"]
      );
      return filteredDone;
    },
    // Setting the data for Regular Post Retail Pricing from Pricing Data
    fenceStyleForRegularPostRetail: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Regular Posts Retail"]
      );
      return filteredDone;
    },
    // Setting the data for Regular Post Our Cost Pricing from Pricing Data
    fenceStyleForRegularPostOurCost: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Regular Post Our Cost"]
      );
      // let filteredDone = [];
      // this.fencePricing.forEach((element) => {
      //   if (
      //     element.Category === setCategory &&
      //     element.style === setStyle &&
      //     element.color === setColor &&
      //     element.height === setHeight
      //   ) {
      //     filteredDone.push(element["Regular Post Our Cost"]);
      //   }
      // });
      return filteredDone;
    },
    // Setting the data for EndPostsRetail from Pricing Data
    fenceStyleForEndPostRetail: function () {
      var filteredDone;
      if (this.datAcategoryOfFence == "Chain Link") {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        filteredDone = filteredForHeight.map(
          (element) => element["End Posts Retail"]
        );
      } else {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        filteredDone = filteredForHeight.map(
          (element) => element["Regular Posts Retail"]
        );
      }
      return filteredDone;
    },
    // Setting the data for EndPostsOurCost from Pricing Data
    fenceStyleForEndPostOurCost: function () {
      var filteredDone;
      if (this.datAcategoryOfFence == "Chain Link") {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        filteredDone = filteredForHeight.map(
          (element) => element["End Posts Our Cost"]
        );
      } else {
        let setCategory = this.datAcategoryOfFence;
        let setStyle = this.datAstyleOfFence;
        let setColor = this.datAcolorOfFence;
        let setHeight = this.datAheightOfFence;
        let filteredForCategory = this.fencePricing.filter(
          (element) => element.Category === setCategory
        );
        let filteredForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filteredForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        filteredDone = filteredForHeight.map(
          (element) => element["Regular Post Our Cost"]
        );
      }
      return filteredDone;
    },
    // Setting the data for CornerPostRetail from Pricing Data
    fenceStyleForCornerPostRetail: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Corner Posts Retail"]
      );
      return filteredDone;
    },
    // Setting the data for CornerPostOurCost from Pricing Data
    fenceStyleForCornerPostOurCost: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Corner Post Our Cost"]
      );
      return filteredDone;
    },
    amountOfHeavyDutyPostsRetail: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Heavy Duty End Post Retail"]
      );
      var retail;
      if (this.datAcategoryOfFence == "Aluminum") {
        retail = filteredDone[0];
      } else {
        retail = 0;
      }
      return parseFloat(retail) * parseFloat(this.amountOfHeavyDutyPosts);
    },
    amountOfHeavyDutyPostsOurCost: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Heavy Duty End Post Cost"]
      );
      var retail;
      if (this.datAcategoryOfFence == "Aluminum") {
        retail = filteredDone[0];
      } else {
        retail = 0;
      }
      return parseFloat(retail) * parseFloat(this.amountOfHeavyDutyPosts);
    },
    // Setting the data for panelRetail from Pricing Data
    fenceStyleForPanelRetail: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Panel Retail"]
      );
      return filteredDone;
    },
    // Setting the data for panelOurCost from Pricing Data
    fenceStyleForPanelOurCost: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Panel Our Cost"]
      );
      return filteredDone;
    },
    fenceStyleForPanelCost: function () {
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      let filteredDone = filteredForHeight.map(
        (element) => element["Panel Our Cost"]
      );
      return filteredDone;
    },
    fenceStyleForGatePrice: function () {
      // This Returns The Full Matched Set For The Fence
      let setCategory = this.datAcategoryOfFence;
      let setStyle = this.datAstyleOfFence;
      let setColor = this.datAcolorOfFence;
      let setHeight = this.datAheightOfFence;
      var gateStyle = this.datAgateStyle + " Retail";
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      // This Returns The Full Matched Set For The Fence
      let filteredDone = filteredForHeight.map((element) => element[gateStyle]);
      return filteredDone;
    },
    fenceStyleForCapRetail() {
      if (this.datAcapStyle != "Which Style Cap") {
        let filteredForCap = this.fenceCapStyle.filter(
          (element) => element["Cap Style"] == this.datAcapStyle
        );
        return filteredForCap[0].Retail;
      }
      return 0;
    },
    fenceStyleForCapOurCost() {
      if (this.datAcapStyle != "Which Style Cap") {
        let filteredForCap = this.fenceCapStyle.filter(
          (element) => element["Cap Style"] == this.datAcapStyle
        );
        return filteredForCap[0].Cost;
      }
      return 0;
    },
    cornerRetailFinal() {
      var amount;
      if (
        this.datAcategoryOfFence == "Chain Link" &&
        this.datAamountOfCorners >= 1
      ) {
        amount = this.fenceStyleForCornerPostRetail * this.datAamountOfCorners;
      } else if (this.datAamountOfCorners >= 1) {
        amount = this.fenceStyleForRegularPostRetail * this.datAamountOfCorners;
      } else {
        amount = 0;
      }
      return amount;
    },
    cornerOurCostFinal() {
      var amount;
      if (
        this.datAcategoryOfFence == "Chain Link" &&
        this.datAamountOfCorners >= 1
      ) {
        amount = this.fenceStyleForCornerPostOurCost * this.datAamountOfCorners;
      } else if (this.datAamountOfCorners >= 1) {
        amount =
          this.fenceStyleForRegularPostOurCost * this.datAamountOfCorners;
      } else {
        amount = 0;
      }
      return amount;
    },
    capRetailFinal() {
      var amount = 0;
      if (this.datAcategoryOfFence == "Vinyl") {
        amount =
          this.fenceStyleForCapRetail *
          (this.endPosts +
            this.linePosts +
            parseFloat(this.datAamountOfCorners));
      }
      return amount;
    },
    capRetailOurCost() {
      var amount = 0;
      if (this.datAcategoryOfFence == "Vinyl") {
        amount =
          this.fenceStyleForCapOurCost *
          (this.endPosts +
            this.linePosts +
            parseFloat(this.datAamountOfCorners));
      }
      return amount;
    },
    capQty() {
      var amount;
      if (this.datAcategoryOfFence == "Vinyl") {
        amount =
          this.endPosts + this.linePosts + parseFloat(this.datAamountOfCorners);
      } else {
        amount = 0;
      }
      return amount;
    },
    amountOfHeavyDutyPosts() {
      var amount;
      if (this.datAcategoryOfFence == "Aluminum") {
        amount = this.datAgates.length;
      } else {
        amount = 0;
      }
      return amount;
    },
  },
};
</script>
